/*
  请求基础路径
*/
module.exports = {
  // dev_url: 'http://192.168.2.18:8001/', // 舒总环境
  // dev_url: 'http://192.168.2.26:8087/', // 徐哲环境
  // dev_url: 'http://192.168.2.88:8081/', // 许兔环境
  // dev_url: 'https://shijian.hzau.edu.cn/', // 正式环境
  // dev_url: 'https://shijian.hzau.edu.cn/', // 正式环境
  // dev_url: 'https://shijian.hzau.edu.cn/yufabu/', //预发布环境
  // dev_url: 'http://dev.kzmooc.com:9012/', // 对外测试环境
  // dev_url: 'http://dev.kzmooc.com:9013/', // 对外测试环境
  // dev_url: 'http://dev.kzmooc.com:9016/', // 演示环境
  // dev_url: 'http://210.42.73.16/', // 江汉大学
  // dev_url: 'https://ujoy.kzmooc.cn/', // 有教灵镜
  // dev_url: 'https://smart.kzmooc.com/', // 有教灵镜
  // dev_url: 'http://192.168.33.180/',
  // dev_url: 'http://172.30.30.56/', // 武汉东湖学院
  // dev_url: 'https://zhsys.wsyu.edu.cn/', // 首义学院
  // dev_url: 'https://shiyan.lcu.edu.cn/',//聊城大学
  // dev_url: 'http://10.10.4.102/',//国土资源
  dev_url: 'https://zhsj.hbust.edu.cn/',// 湖北科技学院


  // 

  // pro_url: 'https://shijian.hzau.edu.cn/' // 正式环境
  // pro_url: 'https://shijian.hzau.edu.cn/yufabu/' // 预发布环境
  // pro_url: 'https://shijian.hzau.edu.cn/yanshi/' // 演示环境
  // pro_url: 'https://shijian.hzau.edu.cn/develop/' // 调试环境
  // pro_url: 'https://shijian.hzau.edu.cn/sandbox/'
  // pro_url: 'http://jjxy-whcp.kzmooc.cn/', // 预发布环境
  // pro_url: 'http://dev.kzmooc.com:9012/' // 对外测试环境
  // pro_url: 'http://dev.kzmooc.com:9013/', // 对外测试环境
  // pro_url: 'http://dev.kzmooc.com:9016/' // 对外测试环境
  // file_preview: 'http://file-preview.kzmooc.cn/' // 文件查看
  // pro_url: 'http://210.42.73.16/', // 江汉大学
  // pro_url: 'https://hbgt.kzmooc.cn/',
  // pro_url: 'https://smart.kzmooc.com/', // 有教灵镜
  // pro_url: 'http://172.30.30.56/' // 武汉东湖学院
  // pro_url: 'https://zhsys.wsyu.edu.cn/' // 首义学院
  // pro_url: 'https://shiyan.lcu.edu.cn/' // 聊城大学正式环境
  // pro_url: 'http://172.16.12.82', // 国土资源
  // pro_url: 'https://ujoy.kzmooc.cn/',
  pro_url: 'https://zhsj.hbust.edu.cn/',// 湖北科技学院
}
